<template>
  <div
    class="SubscriptionConsumptionEmptyState d-flex flex-column align-center text-center"
    data-locator="subscription-consumption-empty-state"
  >
    <p
      class="SubscriptionConsumptionEmptyState__headline text--medium text--bold text-uppercase text-text-tertiary mb-2"
      data-locator="subscription-consumption-empty-state-headline"
    >
      {{ $t('subscriptions.views.SubscriptionConsumption.emptyState.headline') }}
    </p>

    <h2
      class="SubscriptionConsumptionEmptyState__title font-weight-light text-text-primary mb-4"
      data-locator="subscription-consumption-empty-state-title"
    >
      {{ $t('subscriptions.views.SubscriptionConsumption.emptyState.title') }}
    </h2>

    <i18n-t
      keypath="subscriptions.views.SubscriptionConsumption.emptyState.text"
      tag="p"
      scope="global"
      class="SubscriptionConsumptionEmptyState__text text--small text-text-secondary mb-6"
      data-locator="subscription-consumption-empty-state-text"
    >
      <template #learnMore>
        <a
          :href="dataroomLandingPageUrl"
          target="_blank"
          class="SubscriptionConsumptionEmptyState__link d-inline-flex align-center column-gap-1"
          data-locator="subscription-consumption-empty-state-learn-more"
        >
          {{ $t('subscriptions.views.SubscriptionConsumption.emptyState.learnMore') }}
          <app-material-icon name="open_in_new" size="xs" color="inherit" />
        </a>
      </template>
    </i18n-t>

    <app-button
      type="primary"
      variant="brand"
      data-locator="subscription-consumption-empty-state-cta"
      @click="discoverDialogIsOpen = true"
    >
      {{ $t('subscriptions.views.SubscriptionConsumption.emptyState.cta') }}
    </app-button>

    <SubscriptionConsumptionEmptyStateFeatures class="mt-6 w-100" />

    <!--
      Same two-step flow as the home page (ProjectTypeDataroom.vue): the CTA opens the
      discovery dialog, which either requests activation or hands over to the creation
      dialog. Both of its outcomes are handled here so this component does not depend on
      the parent's gating condition.
    -->
    <DiscoverDataroomDialog
      v-if="discoverDialogIsOpen"
      @close="discoverDialogIsOpen = false"
      @createDataroom="createDataroom"
      @requestActivation="openQuoteRequestDialog"
    />

    <ProjectsNewDataroomDialog
      v-if="newDataroomDialogIsOpen"
      :isOpenedFromHome="false"
      @requestActivation="openQuoteRequestDialog"
      @close="newDataroomDialogIsOpen = false"
    />
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'

  import { DATAROOM_LANDING_PAGE_URL } from '@/common/utils/closdInfo'
  import { QUOTE_REQUEST_TOPICS } from '@/common/utils/quoteRequestTopics'
  import DiscoverDataroomDialog from '@/projects/dialogs/DiscoverDataroomDialog.vue'
  import ProjectsNewDataroomDialog from '@/projects/dialogs/ProjectsNewDataroomDialog.vue'
  import { SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG } from '@/store/modules/subscription/mutation_types'
  import SubscriptionConsumptionEmptyStateFeatures from '@/subscriptions/views/SubscriptionConsumptionEmptyStateFeatures.vue'

  export default {
    name: 'SubscriptionConsumptionEmptyState',
    components: {
      DiscoverDataroomDialog,
      ProjectsNewDataroomDialog,
      SubscriptionConsumptionEmptyStateFeatures,
    },
    data () {
      return {
        dataroomLandingPageUrl: DATAROOM_LANDING_PAGE_URL,
        discoverDialogIsOpen: false,
        newDataroomDialogIsOpen: false,
      }
    },
    methods: {
      ...mapMutations('subscription', [SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG]),
      createDataroom () {
        this.discoverDialogIsOpen = false
        this.newDataroomDialogIsOpen = true
      },
      openQuoteRequestDialog () {
        this.SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG({
          isOpen: true,
          defaultProjectType: QUOTE_REQUEST_TOPICS.DATAROOM,
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .SubscriptionConsumptionEmptyState {
    &__headline {
      letter-spacing: 1.5px;
    }

    // No typography token matches 40px, so this is applied this way
    // line-height needs !important to beat the global h2 rule.
    // Those values are straight from the mockup design
    &__title {
      font-size: 40px;
      line-height: 48px !important;
      max-width: 620px;
    }

    &__text {
      max-width: 620px;
    }

    &__link {
      text-decoration: underline;
    }
  }
</style>
